import { LoadingButton } from 'components/Material/index'
import { SxProps } from '@mui/system'
import useTextStyles from 'styles/useTextStyles'

type ButtonProps = {
  children: React.ReactNode
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  disabled?: boolean
  className?: string
  type?: 'button' | 'submit' | 'reset'
  form?: 'primary' | 'secondary' | 'tertiary'
  sx?: SxProps
  startIcon?: React.ReactNode
  loading?: boolean
  title?: string
}

export const FilledButton = ({
  children,
  startIcon,
  onClick,
  disabled = false,
  className,
  type = 'button',
  form = 'primary',
  sx,
  loading = false,
  title,
  ...props
}: ButtonProps) => {
  const colorStyles = {
    primary: {
      bgcolor: '#1856ff',
      color: 'white'
    },
    secondary: {
      bgcolor: 'white',
      color: '#1856ff',
      border: '1px solid #79747E'
    },
    tertiary: {
      bgcolor: 'transparent',
      color: '#1856ff',
      border: '1px solid #79747E'
    }
  }

  const buttonStyles = {
    // py: 1,
    // px: 5,
    height: 40,
    width: '100%',
    maxWidth: '350px',
    borderRadius: '5px',
    textTransform: 'none',
    ...sx,

    ':hover': {
      opacity: 1,
      bgcolor: colorStyles[form].bgcolor
    },
    ':active': {
      opacity: 1,
      bgcolor: colorStyles[form].bgcolor
    },
    ...colorStyles[form],
    '&.Mui-disabled': {
      bgcolor: '#e3dfe3',
      cursor: 'not-allowed'
    },
    className
  }

  return (
    <LoadingButton
      type={type}
      onClick={onClick}
      loading={loading}
      disabled={disabled || loading === true}
      sx={{ ...buttonStyles, ...useTextStyles.labelLarge }}
      title={title || (typeof children === 'string' ? children : undefined)}
      {...props}
    >
      {startIcon}
      {children}
    </LoadingButton>
  )
}
